// src/pages/Banks/CreateBank.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormAddEditBank from '../../components/banks/FormAddEditBank';

const CreateBank = () => {
    const navigate = useNavigate();

    const handleSubmitSuccess = () => {
        navigate('/banks');
    };

    return <FormAddEditBank isEdit={false} onSubmitSuccess={handleSubmitSuccess} />;
};

export default CreateBank;
